//使用nocoDb，调用接口的封装
import axios from "axios";
import querystring from "querystring";
let token = 'yEtpkgji4uA4lXZo-HK7cAFuyVunwlQ3H8BB7uDw'
var cancelTokenCollection = {};

const instance = axios.create({
    validateStatus: function(status) {
        return status < 500;
    },
});
axios.interceptors.request.use(config => {
    config.headers['Xc-Token'] = token
    return config
}, error => {
    return Promise.reject(error)
})
instance.interceptors.response.use(
    (response) => {
        if (response.status == "401") {
            // window.location.href = 'http://' + window.location.host + '/kuailework_h5/my/login2'
        }
        return response
    },
    function(error) {
        return Promise.reject(error);
    }
);
//通过axios发送请求
export default {
    get: function(url, paramObj) {
        var myConfig = {
            'Xc-Token': token
        };
        let urls
        if(paramObj){
            urls = url + '?' +querystring.stringify(paramObj)
        }else{
            urls = url
        }
        return axios.get(urls, paramObj, myConfig);
    },

    post: function(url, paramObj) {
        var myConfig = {
            headers: {
                // 跨域请求 这个配置不能少
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                Accept: "application/json",
                'Xc-Token': token
            },
        };

        // 如果是json格式则不需要转参数
        const params =
            paramObj instanceof FormData ? paramObj : querystring.stringify(paramObj);

        // myConfig.headers.version = '3.0';
        return instance.post(url, params, myConfig);
    },
    patch:(url, paramObj)=>{
        var myConfig = {
            headers: {
                'Xc-Token': token,
                // 跨域请求 这个配置不能少
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                Accept: "application/json",
            },
        };

        // 如果是json格式则不需要转参数
        const params =
            paramObj instanceof FormData ? paramObj : querystring.stringify(paramObj);

        // myConfig.headers.version = '3.0';
        return instance.patch(url, params, myConfig);
    },
    // 终止 ajax 请求， 如 xhr 的 abort 方法
    cancel: function(urlKey) {
        if (!cancelTokenCollection[urlKey]) {
            return;
        }
        cancelTokenCollection[urlKey]();
    },
};
